import React, { Component } from 'react'
import './Dashboard.css'
import './Dashboard-mobile.css'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
 
class Dashboard extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired
  }
  state = {
    isCurrentLoginCourtier: localStorage.getItem("isCurrentLoginCourtier")
  }

  render() {
    const { match, children } = this.props
    const { isCurrentLoginCourtier } = this.state

    return(
      <div>
        <div className="aps-container-center-bloc">
          <div className="uk-section aps-section-dashboard">
            <div className="aps-dashboard-header">
              DASHBOARD
            </div>
            <div className="aps-dashboard-body uk-grid" uk-grid="">
              <div className="uk-width-1-4 aps-dashboard-body-first-col">
                <div className="aps-dashboard-body-container-first">
                  <ul className="uk-list aps-dashboard-sidebar-item-container">
                    <li className={`uk-text-left aps-dashboard-sidebar-item
                      ${match.url === '/souscripteur' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                      ${match.url === '/beneficiaire' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                      ${match.url === '/devis' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                      ${match.url === '/questionnaire' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                      ${match.url === '/data-protection' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                      ${match.url === '/declaration' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                    `}>
                      <Link className="uk-link-reset" to="/souscripteur">
                        {isCurrentLoginCourtier ? "Souscription p/c client" : "Ma souscription"}
                      </Link>
                      <div className="uk-text-right">
                        <div className={`aps-dashboard-sidebar-active
                          ${match.url === '/souscripteur' ? 'aps-dashboard-sidebar-active-this-route' : ''}
                          ${match.url === '/beneficiaire' ? 'aps-dashboard-sidebar-active-this-route' : ''}
                          ${match.url === '/devis' ? 'aps-dashboard-sidebar-sidebar-this-route' : ''}
                          ${match.url === '/questionnaire' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                          ${match.url === '/data-protection' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                          ${match.url === '/declaration' ? 'aps-dashboard-sidebar-item-this-route' : ''}
                        `}></div>
                      </div>
                    </li>
                    {!isCurrentLoginCourtier && (
                      <div className="aps-dashboard-sidebar-divider"></div>
                    )}
                    {!isCurrentLoginCourtier && (
                      <li className={`uk-text-left aps-dashboard-sidebar-item ${match.url === '/parrain' ? 'aps-dashboard-sidebar-item-this-route' : ''}`}>
                        <Link className="uk-link-reset" to="/parrain">Mon lien de parrainage</Link>
                        <div className="uk-text-right"><div className={`aps-dashboard-sidebar-active ${match.url === '/parrain' ? 'aps-dashboard-sidebar-active-this-route' : ''}`}></div></div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              <div className="uk-width-expand aps-dashboard-body-second-col">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js